import React, { createContext, useContext, useState, useCallback, useRef } from "react";
import { auraForAction } from "@/data/mock";

const AuraContext = createContext(null);
export const useAura = () => useContext(AuraContext);

let burstId = 0;

export function AuraProvider({ children }) {
  const [aura, setAura] = useState(4820); // starting demo aura for logged-in user
  const [following, setFollowing] = useState(new Set());
  const [liked, setLiked] = useState(new Set());
  const [saved, setSaved] = useState(new Set());
  const [bursts, setBursts] = useState([]); // {id, amount}
  const [onboarded, setOnboarded] = useState(false);
  const [profile, setProfile] = useState({ name: "", username: "", bio: "", avatar: null, interests: [] });
  const burstAnchor = useRef(null);

  const spawnBurst = useCallback((amount) => {
    const id = ++burstId;
    setBursts((b) => [...b, { id, amount }]);
    setAura((a) => a + amount);
    setTimeout(() => setBursts((b) => b.filter((x) => x.id !== id)), 1600);
  }, []);

  const toggleFollow = useCallback((username) => {
    setFollowing((prev) => {
      const next = new Set(prev);
      if (next.has(username)) {
        next.delete(username);
      } else {
        next.add(username);
        spawnBurst(auraForAction("follow"));
      }
      return next;
    });
  }, [spawnBurst]);

  const toggleLike = useCallback((id) => {
    let added = false;
    setLiked((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else { next.add(id); added = true; }
      return next;
    });
    if (added) spawnBurst(auraForAction("like"));
  }, [spawnBurst]);

  const toggleSave = useCallback((id) => {
    let added = false;
    setSaved((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else { next.add(id); added = true; }
      return next;
    });
    if (added) spawnBurst(auraForAction("save"));
  }, [spawnBurst]);

  const value = {
    aura, setAura, spawnBurst,
    following, toggleFollow, isFollowing: (u) => following.has(u),
    liked, toggleLike, isLiked: (id) => liked.has(id),
    saved, toggleSave, isSaved: (id) => saved.has(id),
    bursts, burstAnchor,
    onboarded, setOnboarded, profile, setProfile,
  };

  return <AuraContext.Provider value={value}>{children}</AuraContext.Provider>;
}
